import {
  Bell,
  BookOpen,
  Bot,
  Briefcase,
  Building2,
  CircleHelp,
  Info,
  LayoutDashboard,
  LogIn,
  Mail,
  ShieldAlert,
  ShieldCheck,
  Swords,
  User,
  type LucideIcon,
} from 'lucide-react';
import { CANDIDATE_PUBLIC_ROUTES } from './candidate-public-routes';

export interface ConsumerNavItem {
  href: string;
  label: string;
  icon: LucideIcon;
}

export const CONSUMER_ROUTES = {
  jobs: { href: '/', label: 'Jobs', icon: Briefcase },
  companies: {
    href: CANDIDATE_PUBLIC_ROUTES.companies,
    label: 'Companies',
    icon: Building2,
  },
  careerGuide: {
    href: CANDIDATE_PUBLIC_ROUTES.careerGuide,
    label: 'Career Guide',
    icon: BookOpen,
  },
  trust: {
    href: CANDIDATE_PUBLIC_ROUTES.trust,
    label: 'Trust & Safety',
    icon: ShieldCheck,
  },
  safety: { href: CANDIDATE_PUBLIC_ROUTES.safety, label: 'Safety', icon: ShieldAlert },
  help: { href: CANDIDATE_PUBLIC_ROUTES.help, label: 'Help', icon: CircleHelp },
  about: { href: CANDIDATE_PUBLIC_ROUTES.about, label: 'About', icon: Info },
  contact: { href: CANDIDATE_PUBLIC_ROUTES.contact, label: 'Contact', icon: Mail },
  dashboard: { href: '/me/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  jobAlerts: { href: '/me/alerts', label: 'Job alerts', icon: Bell },
  arena: { href: '/me/arena', label: 'Arena', icon: Swords },
  coach: { href: '/me/agent', label: 'Coach', icon: Bot },
  profile: { href: '/me/profile', label: 'Profile', icon: User },
  signIn: { href: '/auth/login', label: 'Sign In', icon: LogIn },
} as const satisfies Record<string, ConsumerNavItem>;

export function consumerHeaderNav(options: {
  isTenantDomain: boolean;
  isAuthenticated: boolean;
}): ConsumerNavItem[] {
  return [
    CONSUMER_ROUTES.jobs,
    ...(!options.isTenantDomain
      ? [
          CONSUMER_ROUTES.companies,
          CONSUMER_ROUTES.careerGuide,
          CONSUMER_ROUTES.trust,
          CONSUMER_ROUTES.help,
        ]
      : []),
    ...(options.isAuthenticated ? [CONSUMER_ROUTES.dashboard] : []),
    // Job alerts search the whole public marketplace, so they are an apex
    // destination; tenant career sites keep their minimal signed-in nav.
    ...(options.isAuthenticated && !options.isTenantDomain ? [CONSUMER_ROUTES.jobAlerts] : []),
  ];
}

export function consumerMobileNav(options: {
  isTenantDomain: boolean;
  isAuthenticated: boolean;
}): ConsumerNavItem[] {
  return [
    CONSUMER_ROUTES.jobs,
    ...(options.isAuthenticated
      ? [
          CONSUMER_ROUTES.dashboard,
          CONSUMER_ROUTES.arena,
          CONSUMER_ROUTES.coach,
          CONSUMER_ROUTES.profile,
        ]
      : options.isTenantDomain
        ? []
        : [CONSUMER_ROUTES.signIn]),
  ];
}
